import { memo } from 'react';
import PropTypes from 'prop-types';

const ViewSingleImageModal = (props) => {
    const { isOpenViewSingleImageModal, setIsOpenViewSingleImageModal, viewSingleImage, id } = props;
    return (
        <>
            {isOpenViewSingleImageModal && (
                <div className="modal fade" style={{ background: "rgba(0,0,0, 0.5)" }} id="ViewSingleImageModal" tabIndex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true" data-backdrop="false">
                    <div className="modal-dialog modal-dialog-centered rounded modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Document View</h5>
                                <button type="button" className="close" aria-label="Close" onClick={() => { setIsOpenViewSingleImageModal(false); }}><span aria-hidden="true">&times;</span></button>
                            </div>
                            <div className="col-12">
                                <div className="row d-flex justify-content-center align-items-center">

                                    <div className="imagemodalcontainer" style={{ overflow: 'hidden', width: '620px' }}>
                                        <div style={{ display: 'flex', transition: 'transform 0.3s ease' }}>
                                            <div className="img-box" style={{ flex: '0 0 auto', margin: '0 0px' }}>
                                                <img
                                                    src={id ? viewSingleImage.FileAttachment : URL.createObjectURL(viewSingleImage)}
                                                    style={{
                                                        height: '500px',
                                                        width: '620px',
                                                        maxHeight: '500px',
                                                        maxWidth: '620px',
                                                        objectFit: 'cover'
                                                    }}
                                                    alt="Image not found"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default memo(ViewSingleImageModal);

// PropTypes definition
ViewSingleImageModal.propTypes = {
    isOpenViewSingleImageModal: PropTypes.bool.isRequired,
    setIsOpenViewSingleImageModal: PropTypes.func.isRequired,
    viewSingleImage: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

// Default props
ViewSingleImageModal.defaultProps = {
    viewSingleImage: {},
    id: null
};
